import React, { useState, useEffect } from "react";
import {
  Stack,
  Typography,
  InputBase,
  Box,
  Paper,
  IconButton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

export default function PatientTabHeader({ handleSearchCallback }) {
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    if (searchText.trim().length === 0) {
      handleSearchCallback("fullName", "");
    }
  }, [searchText]);

  const handleSearch = () => {
    handleSearchCallback("fullName", searchText);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSearch();
    }
  };

  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      justifyContent="space-between"
      alignItems={{ xs: 'stretch', md: 'center' }}
      spacing={2}
      mb={{ xs: 3, md: '40px' }}
    >
      <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
        <Typography align="left" sx={{ marginRight: "10px" }}>
          Search :
        </Typography>
      </Box>
      <Box sx={{ width: { xs: '100%', md: 'auto' } }}>
        <Paper
          component="form"
          onSubmit={(e) => e.preventDefault()}
          sx={{
            p: "2px 4px",
            display: "flex",
            alignItems: "center",
            width: { xs: '100%', md: 600 },
            flexDirection: { xs: 'column', sm: 'row' },
            gap: { xs: 1, sm: 0 },
          }}
        >
          <InputBase
            sx={{ ml: 1, flex: 1, width: { xs: '100%', sm: 'auto' } }}
            placeholder="Search by patient name..."
            inputProps={{ "aria-label": "search patient" }}
            value={searchText}
            onChange={(event) => setSearchText(event.target.value)}
            onKeyDown={handleKeyDown}
          />
          <IconButton
            type="button"
            sx={{
              p: "10px",
              backgroundColor: "rgba(0, 0, 0, 0.04)",
              alignSelf: { xs: 'flex-end', sm: 'auto' }
            }}
            aria-label="search"
            onClick={handleSearch}
          >
            <SearchIcon />
          </IconButton>
        </Paper>
      </Box>
    </Stack>
  );
}
